module.exports = {"141102001":"滨河街道","141102002":"凤山街道","141102003":"莲花池街道","141102004":"城北街道","141102005":"田家会街道","141102006":"交口街道","141102007":"西属巴街道","141102100":"吴城镇","141102101":"信义镇","141102200":"红眼川乡","141102201":"枣林乡","141102202":"坪头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141102.json
// module id = 378
// module chunks = 0